import { render, staticRenderFns } from "./p13.vue?vue&type=template&id=7b1302d3&scoped=true&"
import script from "./p13.vue?vue&type=script&lang=js&"
export * from "./p13.vue?vue&type=script&lang=js&"
import style0 from "./p13.vue?vue&type=style&index=0&id=7b1302d3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1302d3",
  null
  
)

export default component.exports